import React from 'react'
import Divider from '@material-ui/core/Divider';
import { Typography } from '@material-ui/core';

export const Footer = () => {
  return (
    <div>
      <footer>
      <Divider/>
      <Typography mx="auto">
      © 2021 Yoshihiro Tamai
      </Typography>
      </footer>
    </div>
  )
}
